export default __webpack_public_path__ + "static/media/desk-ecofriendly.651af217.png";